/* eslint-disable react-hooks/exhaustive-deps */
import {
  Row,
  Col,
  Card,
  Button,
  Avatar,
  Typography,
} from "antd";
import eChart from "../components/chart/configs/eChart";
import BgProfile from "../assets/images/nphl_header_1.jpg";
import mohAvatar from "../assets/images/MOH_LOGO.png";
import project1 from "../assets/images/home-decor-1.jpeg";
import project2 from "../assets/images/home-decor-2.jpeg";
import project3 from "../assets/images/home-decor-3.jpeg";
import EChart from "../components/chart/EChart";
import useAppStore from "../store";
import { fsnrlRoles, gmslRoles, nhrlRoles, nicRoles, nmrlRoles, nobrlRoles, nvrlRoles, coeRoles } from "../constants/roles";
import iframeDashboardSettings from '../constants/dashboardIframeSettings';
import { useHistory } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios";
import { apiRoutes } from "../constants/apiRoutes";

function Home() {
  const user = useAppStore((state) => state.user);
  const aggregatedWorkload = useAppStore((state) => state.aggregatedWorkload);
  const setAggregatedWorkload = useAppStore((state) => state.setAggregatedWorkload);
  const [eChartData, setEChartData] = useState(eChart);
  const { Title } = Typography;
  let history = useHistory();

  const project = [
    {
      id: "fsnrl",
      img: project1,
      title: "Food Safety and Nutrition Laboratory (FSNRL)",
      subtitle: "FSNRL Dashboard",
      titledesc: "Visualizations for the Food Safety Lab",
      description:
        "As Uber works through a huge amount of internal management turmoil.",
    },
    {
      id: "nmrl",
      img: project2,
      title: "National Microbiology Reference Laboratory (NMRL)",
      titledesc: "Visualizations for the Microbiology Lab",
      subtitle: "NMRL Dashboard",
      description:
        "Music is something that every person has his or her own specific opinion about.",
    },
    {
      id: "nic",
      img: project3,
      title: "National Influenza Center (NIC)",
      titledesc: "Visualizations for the Influenza Lab",
      subtitle: "NIC Dashboard",
      description:
        "Different people have different taste, and various types of music, Zimbali Resort",
    },
    {
      id: "gmsl",
      img: project3,
      title: "Genomics and Molecular Surveillance Laboratory (GMSL)",
      titledesc: "Visualizations for the Genomics Lab",
      subtitle: "GMSL Dashboard",
      description:
        "Different people have different taste, and various types of music, Zimbali Resort",
    },
    {
      id: "nobrl",
      img: project3,
      title: "National Oncology and Biochemistry Reference Laboratory (NOBRL)",
      titledesc: "Visualizations for the Oncology Lab",
      subtitle: "NOBRL Dashboard",
      description:
        "Different people have different taste, and various types of music, Zimbali Resort",
    },
    {
      id: "nhrl",
      img: project3,
      title: "National HIV Reference Laboratory (NHRL)",
      titledesc: "Visualizations for the HIV Lab",
      subtitle: "NHRL Dashboard",
      description:
        "Different people have different taste, and various types of music, Zimbali Resort",
    },
    {
      id: "nvrl",
      img: project3,
      title: "National Virology Reference Laboratory (NVRL)",
      titledesc: "Visualizations for the Virology Lab",
      subtitle: "NVRL Dashboard",
      description:
        "Different people have different taste, and various types of music, Zimbali Resort",
    },
    {
      id: "coe",
      img: project3,
      title: "Center of Excellence (COE)",
      titledesc: "Visualizations for the COE Center",
      subtitle: "COE Dashboard",
      description:
        "Different people have different taste, and various types of music, Zimbali Resort",
    },
  ];
  const stack = [
    <svg key={0} width="22px" height="22px" viewBox="0 0 0.44 0.44" xmlns="http://www.w3.org/2000/svg" version="1.1" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="0.03"><path d="m0.048 0.302 0.172 0.09 0.172 -0.09M0.048 0.22 0.22 0.309 0.392 0.22M0.22 0.048l-0.172 0.09 0.172 0.089 0.172 -0.089z" /></svg>,
  ];
  const trend = [
    <svg key={0} fill="#fff" width="22px" height="22px" viewBox="0 0 0.66 0.66" id="up-trend" xmlns="http://www.w3.org/2000/svg"><path id="primary" d="M0.578 0.138h-0.11a0.028 0.028 0 0 0 0 0.055h0.044L0.385 0.319l-0.063 -0.063a0.028 0.028 0 0 0 -0.039 0l-0.22 0.22a0.028 0.028 0 0 0 0 0.039 0.028 0.028 0 0 0 0.039 0l0.2 -0.201 0.063 0.063a0.028 0.028 0 0 0 0.039 0L0.55 0.231V0.275a0.028 0.028 0 0 0 0.055 0V0.165a0.028 0.028 0 0 0 -0.028 -0.028" /></svg>,
  ];
  const heart = [
    <svg
      width="22"
      height="22"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.17157 5.17157C4.73367 3.60948 7.26633 3.60948 8.82843 5.17157L10 6.34315L11.1716 5.17157C12.7337 3.60948 15.2663 3.60948 16.8284 5.17157C18.3905 6.73367 18.3905 9.26633 16.8284 10.8284L10 17.6569L3.17157 10.8284C1.60948 9.26633 1.60948 6.73367 3.17157 5.17157Z"
        fill="#fff"
      ></path>
    </svg>,
  ];
  const cart = [
    <svg key={0} width="22px" height="22px" viewBox="0 0 0.66 0.66" version="1.1" xmlns="http://www.w3.org/2000/svg"><g stroke="none" strokeWidth="1" fill="none"><path d="M0.546 0.412q0.002 0 0.005 0za0.055 0.055 0 0 1 0.015 0.002C0.586 0.422 0.605 0.446 0.605 0.474c0 0.034 -0.026 0.062 -0.059 0.062s-0.059 -0.028 -0.059 -0.062c0 -0.024 0.013 -0.045 0.032 -0.055l0.001 0q0.001 -0.001 0.003 -0.001l-0.004 0.002a0.058 0.058 0 0 1 0.022 -0.007q0.002 0 0.005 0M0.114 0.412q0.003 0 0.005 0za0.058 0.058 0 0 1 0.025 0.006c0.02 0.01 0.033 0.031 0.033 0.056 0 0.034 -0.026 0.062 -0.059 0.062C0.081 0.536 0.055 0.509 0.055 0.474c0 -0.031 0.021 -0.056 0.049 -0.061a0.055 0.055 0 0 1 0.01 -0.001m0.311 -0.103a0.017 0.017 0 0 1 0.017 0.017 0.017 0.017 0 0 1 -0.002 0.007l0 0 -0.086 0.142a0.033 0.033 0 0 1 -0.006 0.009c-0.006 0.006 -0.014 0.01 -0.024 0.01 -0.018 0 -0.033 -0.015 -0.033 -0.034 0 -0.008 0.003 -0.016 0.008 -0.022l0.001 -0.001 0 0 0.114 -0.124a0.017 0.017 0 0 1 0.011 -0.004m-0.01 -0.124c0.08 0.033 0.138 0.112 0.145 0.206a0.076 0.076 0 0 0 -0.042 0.004c-0.006 -0.075 -0.051 -0.138 -0.114 -0.167 0.006 -0.011 0.01 -0.023 0.011 -0.036zl0 0Zm-0.16 -0.005q0 0.002 0 0.005c0 0.014 0.003 0.027 0.009 0.039 -0.068 0.026 -0.118 0.092 -0.124 0.171a0.076 0.076 0 0 0 -0.042 -0.003c0.007 -0.094 0.065 -0.173 0.145 -0.207l0.007 -0.003zM0.335 0.124c0.03 0 0.055 0.023 0.058 0.054q0 0 0 0l0 0.003a0.066 0.066 0 0 1 0 0.01l0 -0.005a0.066 0.066 0 0 1 -0.002 0.017 0.063 0.063 0 0 1 -0.008 0.019A0.058 0.058 0 0 1 0.335 0.247c-0.024 0 -0.045 -0.016 -0.054 -0.038l-0.001 -0.004 -0.001 -0.002a0.063 0.063 0 0 1 -0.003 -0.018 0.066 0.066 0 0 1 0.001 -0.011C0.283 0.145 0.307 0.124 0.335 0.124" fill="#fff" fillRule="nonzero" /></g></svg>,
  ];
  const topTrendsData = [
    {
      today: "Customer Satisfaction",
      title: "--",
      persent: "--",
      icon: heart,
      bnb: "redtext",
    },
    {
      today: "EQA Performance",
      title: "--",
      persent: "--",
      icon: cart,
      bnb: "bnb2",
    },
  ];

  const [topTrends, setTopTrends] = useState(topTrendsData);

  function numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

  useEffect(() => {
    if (!aggregatedWorkload?.length <= 0) {
      let sumWorkload = 0;
      aggregatedWorkload.forEach((w) => {
        sumWorkload += w.workload;
      });
      const trend1 = {
        today: "Total Workload (last 12 months)",
        title: numberWithCommas(sumWorkload),
        persent: "",
        icon: stack,
        bnb: "bnb2",
      };

      const latestWorkload = aggregatedWorkload[aggregatedWorkload.length - 1].workload;
      const secondLatestWorkload = aggregatedWorkload[aggregatedWorkload.length - 2].workload;
      const workloadDiff = (latestWorkload - secondLatestWorkload) / secondLatestWorkload * 100;
      const trend2bnb = workloadDiff < 0 ? "redtext" : "bnb2";

      const trend2 = {
        today: "Workload Trend (this month)",
        title:  numberWithCommas(latestWorkload),
        persent: `${(workloadDiff < 0 ? "-" : "+") + workloadDiff.toFixed(0)}% from last month`,
        icon: trend,
        bnb: trend2bnb,
      };

      const topTrendsCpy = [trend1, trend2, ...topTrendsData];
      setTopTrends(topTrendsCpy);
    }
  }, [aggregatedWorkload]);

    // TODO: eChart
  // set: eChart.options.xaxis.categories
  // set: eChart.series[0].keys
  useEffect(() => {
    if (aggregatedWorkload?.length <= 0) {
      axios.get(`${process.env.REACT_APP_ANALYTICS_API_URL}${apiRoutes.workload}`)
      .then((res) => {
        setAggregatedWorkload(res.data);
      })
      .catch((e) => {
        console.log("error fetching workload: ", e.message);
      });
    } else {
      const eChartCpy = Object.assign({}, eChart);
      const workloadData = [];
      const categories = [];
      aggregatedWorkload.forEach((workloadObj) => {
        workloadData.push(workloadObj.workload);
        categories.push(new Date(workloadObj.date).toLocaleString('default', { month: 'long' }));
      })
      eChartCpy.series[0].data = workloadData;
      eChartCpy.options.xaxis.categories = categories;
      setEChartData(eChartCpy);
    }
  }, [aggregatedWorkload, setAggregatedWorkload]);

  return (
    <>
      <div
        className="profile-nav-bg mb-24"
        style={{ backgroundImage: "url(" + BgProfile + ")" }}
      ></div>

      <Card
        className="card-profile-head"
        bodyStyle={{ display: "none" }}
        title={
          <Row justify="space-between" align="middle" gutter={[24, 0]}>
            <Col span={24} md={12} className="col-info">
              <Avatar.Group>
                <Avatar size={74} shape="square" src={mohAvatar} />
                <div className="avatar-info">
                  <h4 className="font-semibold m-0">National Public Health Laboratories Dashboards</h4>
                </div>
              </Avatar.Group>
            </Col>
          </Row>
        }
      ></Card>

      <Row className="rowgap-vbox" gutter={[24, 0]}>
        {topTrends.map((c, index) => (
          <Col
            key={index}
            xs={24}
            sm={24}
            md={12}
            lg={6}
            xl={6}
            className="mb-24"
          >
            <Card bordered={false} className="criclebox ">
              <div className="number">
                <Row align="middle" gutter={[24, 0]}>
                  <Col xs={18}>
                    <span>{c.today}</span>
                    <Title level={3}>
                      {c.title} <small className={c.bnb}>{c.persent}</small>
                    </Title>
                  </Col>
                  <Col xs={6}>
                    <div className="icon-box">{c.icon}</div>
                  </Col>
                </Row>
              </div>
            </Card>
          </Col>
        ))}
      </Row>

      <Row gutter={[24, 0]}>
        <Col span={24} className="mb-24">
          <Card bordered={false} className="criclebox h-full">
            <EChart eChartData={eChartData} />
          </Card>
        </Col>
      </Row>

      <Row gutter={[24, 0]}>
        {project.filter((dash) => {
          if (dash.id === "fsnrl" && user?.roles.some(v => fsnrlRoles.includes(v))) return dash
          if (dash.id === "nmrl" && user?.roles.some(v => nmrlRoles.includes(v))) return dash
          if (dash.id === "nic" && user?.roles.some(v => nicRoles.includes(v))) return dash
          if (dash.id === "gmsl" && user?.roles.some(v => gmslRoles.includes(v))) return dash
          if (dash.id === "nobrl" && user?.roles.some(v => nobrlRoles.includes(v))) return dash
          if (dash.id === "nhrl" && user?.roles.some(v => nhrlRoles.includes(v))) return dash
          if (dash.id === "nvrl" && user?.roles.some(v => nvrlRoles.includes(v))) return dash
          if (dash.id === "coe" && user?.roles.some(v => coeRoles.includes(v))) return dash
          return false;
        }).map((p, index) => {
          return (
            <Col key={index} xs={24} sm={24} md={12} lg={12} l={8} className="mb-24">
              <Card
                bordered={false}
                className="header-solid mb-24"

              >
                <Card
                  bordered={false}
                  className="card-project"
                  cover={
                    <Card bordered={false} className="criclebox h-full" style={{ height: iframeDashboardSettings[p.id].height }}>
                      {/* <LineChart /> */}
                      <iframe
                        title={p.id}
                        src={iframeDashboardSettings[p.id].workloadSrc}
                        style={{
                          height: iframeDashboardSettings[p.id].height,
                          border: "none",
                          overflow: "visible",
                          overflowClipMargin: "unset",
                          clipPath: "polygon(0 0, 100% 0, 100% 90%, 0 90%)"
                        }}
                        width={iframeDashboardSettings[p.id].width}
                        height={iframeDashboardSettings[p.id].height}
                      ></iframe>
                    </Card>
                  }
                >
                  <div className="card-tag">{p.title}</div>
                  <h5>{p.subtitle}</h5>
                  <p>{p.titledesc}</p>
                  <Row gutter={[6, 0]} className="card-footer">
                    <Col span={12}>
                      <Button type="button" onClick={() => { history.push(iframeDashboardSettings[p.id].dashboardLocation) }}>View Dashboard</Button>
                    </Col>
                  </Row>
                </Card>
              </Card>
            </Col>
          )
        })}
      </Row>

    </>
  );
}

export default Home;
